import { GALLERY } from "@/lib/eventConfig";
import useReveal from "@/hooks/useReveal";

function GalleryItem({ item, index }) {
  const ref = useReveal();
  return (
    <div
      ref={ref}
      className={`reveal relative overflow-hidden rounded-[2rem] sm:rounded-[2.5rem] ${item.span} ${item.ratio}`}
      style={{ transitionDelay: `${index * 120}ms` }}
      data-testid={`gallery-item-${index}`}
    >
      <img
        src={item.src}
        alt={item.alt}
        className="gallery-img absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
    </div>
  );
}

export default function Gallery() {
  const headerRef = useReveal();
  return (
    <section
      className="relative py-24 sm:py-32 lg:py-40 px-6"
      data-testid="gallery-section"
    >
      <div className="max-w-6xl mx-auto">
        <div ref={headerRef} className="reveal text-center max-w-2xl mx-auto">
          <p className="label-eyebrow">A glimpse</p>
          <h2 className="font-serif-display text-4xl sm:text-5xl md:text-6xl text-[#4A5346] mt-6">
            Moments held in light
          </h2>
          <p className="text-[#757E70] mt-6 leading-relaxed">
            A small collection of the imagery that accompanies Odysseas in his young life.
          </p>
        </div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-12 auto-rows-auto gap-6 sm:gap-8">
          {GALLERY.map((item, idx) => (
            <GalleryItem key={idx} item={item} index={idx} />
          ))}
        </div>
      </div>
    </section>
  );
}
